<template>
    <div id="app">
        <el-container>
            <el-header style="line-height: 46px;height: 46px">
                <main-bar></main-bar>
            </el-header>
        </el-container>
        <router-view></router-view>
    </div>
</template>

<script>
    import MainBar from "./components/MainBar";
    import {mapMutations, mapActions} from 'vuex'

    export default {
        name: 'app',
        components: {MainBar},
        methods: {
            loadUserInfo() {
                const url = '/order_platform/api/users/current_user/'
                // const url = '/api/users/current_user/'
                this.$getRequest(url)
                    .then(response => {
                        const userInfo = response.data
                        this.setUserInfo(userInfo)
                    })
                    .catch(error=>{
                        this.$message({
                            type:'error',
                            showClose:true,
                            message:'加载用户信息失败，请刷新页面 或 重新登陆！',
                        })
                    })
            },
            ...mapActions(["loadProduceGroups"]),
            ...mapMutations(['setUserInfo'])
        },
        created() {
            // 全局加载某些属性
            this.loadUserInfo()
            this.loadProduceGroups()
        }
    }
</script>

<style>
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    body {
        margin: 0;
        padding: 0;
    }

    .el-main {
        padding: 0;
        margin: 0
    }

    .el-header {
        padding: 0;
        margin: 0;
        height: 45px;
        line-height: 45px
    }

    .el-table td, .el-table th {
        padding: 5px 0;
    }

    .el-dialog__header {
        padding: 8px 20px;
        text-align: center;
    }

    .el-dialog__body {
        padding: 10px 20px;
        font-size: 13px;
    }

    .el-button {
        font-size: 13px;
    }

    .el-table {
        font-size: 13px;
    }

    .el-header {
        height: 40px;
    }

    .el-table td, .el-table th {
        padding: 3px 0;
    }

    .el-divider--horizontal {
        margin: 10px 0;
    }

    .el-popover {
        font-size: 13px;
        padding: 5px;
    }

    .el-table-column div {
        margin-bottom: 5px;
    }

    .el-link {
        font-size: 13px;
    }

    .el-timeline-item {
        padding-bottom: 15px;
    }

    .el-timeline {
        padding: 15px 15px;
    }

    p {
        margin: 9px 5px;
    }

    .text-danger {
        color: #F56C6C;
    }

    .text-success {
        color: #67C23A;
    }

    .bg-success {
        background-color: #67C23A;
    }

    .text-warning {
        color: #E6A23C;
    }

    .text-info {
        color: #909399;
    }

    .text-main {
        color: #303133;
    }


    .el-menu-item {
        font-size: 13px;
    }

    .el-tabs__item {
        padding: 0 20px;
        height: 25px;
        line-height: 25px;
        font-size: 13px;
    }

    .el-table__expanded-cell[class*="cell"] {
        padding: 8px 30px;
    }

    .gray {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    }

    .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
    }

    .el-scrollbar {
        overflow: hidden;
        width: 340px;
        position: fixed;
        top: 0;
        bottom: 0;
        margin-top: 47px;
        transition: padding-top .3s;
    }

    .el-scrollbar-main {
        overflow: hidden;
        position: fixed;
        top: 0;
        bottom: 0;
        margin-top: 47px;
        transition: padding-top .3s;

    }

    .el-scrollbar__wrap {
        height: 100%;
        overflow-x: auto;
    }

    .el-scrollbar__wrap-main {
        height: 100%;
        overflow-x: auto;
        padding: 10px 0;
        padding-left: 10px;
        padding-right: 250px;
    }

    .el-scrollbar-item {
        display: block;
        height: 40px;
        color: #444;
        line-height: 40px;
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 400;

    }


    code {
        padding: 2px 4px;
        font-size: 90%;
        color: #c7254e;
        background-color: #f9f2f4;
        border-radius: 4px;
    }

    .el-scrollbar__wrap-main p {
        word-spacing: 0.05em;
        line-height: 1.6em;
        margin: 1.2em 0 -1.2em;
        padding-bottom: 1.2em;
        position: relative;
        z-index: 1;
    }

    .el-button--mini, .el-button--mini.is-round {
        padding: 5px 8px;
    }

    .el-scrollbar {
        overflow: hidden;
        width: 220px;
        position: relative;
        top: 0;
        bottom: 0;
        margin-top: 0;
        transition: padding-top .3s;
        text-align: left;
    }

</style>
